import i18n from "@/i18ns/i18n";
import commonFunction from "@/commons/commonFunction";
import store from "@/stores/store";

/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
  /**
   * Đối tượng cache lại các component popup
   */
  _components = {};

  /**
   * Danh sách các popup đang hiển thị
   * key: tên popup
   * value: instance
   */
  _visible = {};

  /**
   * Ẩn tất cả các popup đang hiển thị đi
   */
  hideAll() {
    const me = this;
    let names = [];
    for (let i in me._visible) {
      names.push(i);
    }
    names.forEach((item) => {
      me.hide(item);
    });
  }

  /**
   * Ẩn popup theo tên nếu đang hiển thị
   */
  hide(name) {
    let popup = this._visible[name];
    if (popup) {
      delete this._visible[name];
      popup.hide();
    }
  }

  /**
   * Hiển popup chi tiết
   * @param {Object} owner Form/Component gọi show
   * @param {EnumQuickAdd} type Loại popup
   * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
   * @param {Object} options Các biến hỗ trợ điều khiền luồng
   * @public
   */
  show(owner, type, data, options) {
    var me = this,
      component = me._components[type];
    if (!type) {
      throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
    } else {
      var promise;
      options = options ? options : {};
      me._customParam(type, options);
      if (!component) {
        component = me._loadComponent(type);

        if (component) {
          promise = new Promise((resolve, reject) => {
            var fnSuccess = function (module) {
              if (module) {
                var popupModule = module.default;
                if (popupModule) {
                  me._components[type] = popupModule;
                  me._show(type, popupModule, owner, options, data).then(
                    (record) => {
                      resolve(record);
                    },
                    function (error) {
                      reject(error);
                    },
                  );
                }
              }
            };

            var fnFailure = function (error) {
              commonFunction.handleException(error);
              reject(error);
            };

            component.then(fnSuccess, fnFailure);
          });
        }
      } else {
        promise = me._show(type, component, owner, options, data);
      }

      return promise;
    }
  }

  /**
   * Thực hiện load các component quickAdd theo type
   * @privates
   */
  _loadComponent(type) {
    var component;
    switch (type) {
      /*
            /*
             * form Detail cơ cấu tổ chức
             * pvduy 06/01/2021
             */
      case "OrganizationUnitDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/organizationunit/OrganizationUnitDetail.vue"
        );
        break;
      case "CustomerDetail":
        component = import("@/views/customer/CustomerDetail.vue");
        break;
      /*
       * form Detail vai trò
       * ĐVThi 12/01/2021
       */
      case "UserDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SubAccount/UserDetail.vue"
        );
        break;
      /*
       * form xoa nguoi dung
       * ndbinh 04/01/2022
       */
      case "PopupDeleteSubUser":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SubAccount/PopupDeleteSubUser.vue"
        );
        break;
      /*
       * form thiết lập thông tin kết nối JetPay
       * NDBINH 26/08/2021
       */
      case "SettingShop":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SettingMemas/SettingShop.vue"
        );
        break;
      /*
       * form thiết lập thông tin kết nối JetPay
       * NDBINH 26/08/2021
       */
      case "SettingWebsite":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SettingMemas/SettingWebsite.vue"
        );
        break;
      /*
       * form thiết lập thông tin kết nối thành công
       * NDBINH 27/08/2021
       */
      case "SettingSuccess":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SettingMemas/SettingSuccess.vue"
        );
        break;
      /*
       * popup confirm xác nhận thỏa thuật dịch vụ
       * NDBINH 27/08/2021
       */
      case "SettingConfirm":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SettingMemas/SettingConfirm.vue"
        );
        break;
      /*
       * form điều khoản sử dụng dịch vụ
       * NDBINH 27/08/2021
       */
      case "TermsOfUse":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SettingMemas/TermsOfUse.vue"
        );
        break;
      /*
       * form thiết lập thông tin kết nối JetPay misa
       * NDBINH 09/12/2021
       */
      case "PopupSettingMisa":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/MemasSetting/PopupSettingMisa.vue"
        );
        break;
      case "PopupUpdateInfoMerActive":
        component = import("@/views/ProfileInfo/popup/PopupUpdateInfoMerActive.vue");
        break;
      case "PopupUpdateInfoMerNotActive":
        component = import("@/views/ProfileInfo/popup/PopupUpdateInfoMerNotActive.vue");
        break;

      /*
       * form thiết lập thông tin kết nối JetPay website, ứng dụng khác
       * NDBINH 09/12/2021
       */
      case "PopupSettingWebsiteDiffirent":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/MemasSetting/PopupSettingWebsiteDiffirent.vue"
        );
        break;
      /*
       * form danh sách thêm người dùng
       * nnlam 28/04/2021
       */
      case "ListUserAdd":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/user/ListUserAdd.vue"
        );
        break;
      case "AddSubAccount":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/SubAccount/SubAccountAdd.vue"
        );
        break;
      case "CrossCheckingDetail":
        component = import("@/views/TransactionControl/CrossCheckingDetail.vue");
        break;
      case "AddRole":
        {
          component = import("@/views/usersystem/role/RoleDetailPopup.vue");
        }
        break;
      case "TransactionDetail":
        {
          component = import("@/views/transaction/TransactionDetails.vue");
        }
        break;

      case "RefundDetail":
        {
          component = import("@/views/Refund/RefundDetails.vue");
        }
        break;

      case "AddMerchant":
        {
          component = import("@/views/add-merchant/AddMerchantPopup.vue");
        }
        break;

      /*
       * form danh sách thêm người dùng
       * nnlam 28/04/2021
       */
      case "PopupUserPermissions":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/user/PopupUserPermissions.vue"
        );
        break;
      /*
       * popup phân quyền cho người dùng trên danh sách vai trò
       * tmchi 14.5.2021
       */
      case "PopupRolePermissions":
        component = import("@/views/usersystem/role/PopupRolePermissions.vue");
        break;
      /*
       * form chi tiết người dùng
       * nnlam 28/04/2021
       */
      case "UserJoinRoleDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/user/UserJoinRoleDetail.vue"
        );
        break;
      /*
       * form chi tiết vai trò
       * nnlam 28/04/2021
       */
      case "RoleJoinUserDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/role/RoleJoinUserDetail.vue"
        );
        break;
      /*
       * form DBOption
       * ĐVThi 12/01/2021
       */
      case "dboption":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/dboption/DBOptionDetail.vue"
        );
        break;
      /*
       * form Detail vai trò
       * ĐVThi 12/01/2021
       */
      case "RoleDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/role/RoleDetail.vue"
        );
        break;

      case "RoleSelectEmployee":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/usersystem/role/RoleSelectEmployee.vue"
        );
        break;

      case "AllocationSelectEmployee":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/quicksearch/AllocationSelectEmployee.vue"
        );
        break;

      case "ManagerSearch":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/quicksearch/ManagerSearch.vue"
        );
        break;
      /*
       * form Detail vị trí địa lý
       * pvduy 07/01/2021
       */
      case "LocationDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/location/LocationDetail.vue"
        );
        break;
      /*
       * form tìm nhanh vị trí
       * nvhai 2021.10.05
       */
      case "LocationSearch":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/quicksearch/LocationSearch.vue"
        );
        break;
      /*
       * Form chi tiết nhân viên
       */
      case "EmployeeDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/employee/EmployeeDetail.vue"
        );
        break;
      /*
       * Form chi tiết nhân viên
       */
      case "TemplateDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/document/TemplateDetail.vue"
        );
        break;
      /*
       * Form sửa mẫu báo cáo động
       */
      case "ReportTemplate":
        component = import(
          /*webpackChunkName:'report'*/
          "@/views/report/ReportTemplate.vue"
        );
        break;

      /*
       * form thêm bản ghi kiểm kê
       * ntnghia 06/02/2021
       */
      case "AuditDetail":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/AuditDetail.vue"
        );
        break;

      case "AuditIncrementDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/audit/AuditIncrementDetail.vue"
        );
        break;

      case "AuditDecrementDetail":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/audit/AuditDecrementDetail.vue"
        );
        break;

      case "YetAuditStart":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/YetAuditStart.vue"
        );
        break;

      /**
       * Form chi tiết đang kiểm kê
       * @author ntnghia - 05.05.2021
       */
      case "AuditDetailDoing":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DoingAudit.vue"
        );
        break;
      case "AuditSynchronized":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DoingAuditSynchronized.vue"
        );
        break;
      case "msAttachmentViewer":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/components/msattachment/msAttachmentViewer.vue"
        );
        break;
      /**
       * Form hoàn thành kiểm kê
       * @author ntnghia - 05.05.2021
       */
      case "AuditDone":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DoingAuditCompleted.vue"
        );
        break;

      case "AuditResult":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DoingAuditResult.vue"
        );
        break;
      /**
       * Form chi tiết kiểm kê chưa kiểm kê
       * @author vvkiet - 05.05.2021
       */
      case "YetAuditDetail":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/YetAuditDetail.vue"
        );
        break;
      /**
       * Form chi tiết kiểm kê Đã kiểm kê
       * @author NTAnh2 - 07.05.2021
       */
      case "DoneAuditDetail":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DoneAuditDetail.vue"
        );
        break;
      /**
       * Form chi tiết kiểm kê Đã kiểm kê
       * @author NTAnh2 - 07.05.2021
       */
      case "DiffAuditDetail":
        component = import(
          /*webpackChunkName:'report-template'*/
          "@/views/audit/DiffAuditDetail.vue"
        );
        break;
      case "Import":
        component = import(
          /*webpackChunkName:'import'*/
          "@/views/import/ImportPopup.vue"
        );
        break;
      // Popup duyệt merchant
      case "ConfirmRegistedByLandingPage":
        component =
          import("@/views/SignUpPaymentGateways/tuitionregistrationform/ApproveMerchantLandingPagePopup.vue");
        break;
      // Popup duyệt merchant
      case "ConfirmRegistedByLandingPageV2":
        component =
          import("@/views/SignUpPaymentGateways/RegistrationFormByLandingpage/ApproveMerchantLandingPagePopup.vue");
        break;
      // Popup duyệt merchant
      case "RegistedSuccessLandingPage":
        component =
          import("@/views/SignUpPaymentGateways/tuitionregistrationform/RegistedSuccessLandingPagePopup.vue");
        break;
      case "ImportProgress":
        component = import(
          /*webpackChunkName:'import'*/
          "@/views/import/ImportProgress.vue"
        );
        break;
      case "MsConfigListLayout":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/components/layout/MsConfigListLayout.vue"
        );
        break;

      case "CreateRefund":
        component = import("@/views/transaction/CreateRefund.vue");
        break;
      case "CustomField":
        /**
         * Tùy chỉnh custom field
         */
        component = import(
          /*webpackChunkName:'CustomField'*/
          "@/components/mscustomfield/MsCustomFieldEdit.vue"
        );
        break;
      case "CustomFieldOption":
        /**
         * Tùy chỉnh custom field
         */
        component = import(
          /*webpackChunkName:'CustomField'*/
          "@/components/mscustomfield/MsCustomFieldEditOption.vue"
        );
        break;
      /**
       * @author nvhai - 08.04.2021
       * Form bắt đầu sử dụng
       */
      case "GettingStarted":
        component = import("@/views/getting/GettingStartedNew.vue");
        break;
      /**
       * @author nnlam - 24.04.2021
       * Form chọn nhanh tài sản còn có thể sử dụng
       */
      case "MSPrintViewer":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/components/report/MSPrintViewer.vue"
        );
        break;
      /**
       * pvduy 26/04/2021
       * Form tùy chọn.
       */
      case "/option":
        component = import(
          /*webpackChunkName:'popup'*/
          "@/views/option/Option.vue"
        );
        break;
      /**
       *  Hiển thị QRCode
       * CreatedBy: tmquy (25/08/2021)
       */
      case "PaymentLinkQRCode":
        component = import("@/views/paymentlink/PaymentLinkQRCode.vue");
        break;
      case "LicenseConfirm":
        component = import("@/views/license-agreement/LicenseConfirm.vue");
        break;
      case "LicenseConfirmDetail":
        component = import("@/views/license-agreement/LicenseConfirmDetail.vue");
        break;
      /**
       * Popup thêm mới payment request
       */
      case "CreateRevenueManagementPopup":
        component = import("@/views/revenuemanagement/popup/CreateRevenueManagementPopup.vue");
        break;
      /**
       * Popup thêm mới payment request
       */
      case "SyncFromAmisKeToanPopup":
        component = import("@/views/revenuemanagement/popup/SyncFromAmisKeToanPopup.vue");
        break;
      /**
       * Popup hiển thị thêm mới
       */
      case "CustomerOwnerDetail":
        component = import("@/views/revenuemanagement/popup/CustomerDetail.vue");
        break;
      /**
       * Popup hiển thị tìm kiếm nhanh
       *
       */
      case "PaymentRequestSearch":
        component = import("@/views/revenuemanagement/popup/PaymentRequestSearch.vue");
        break;

      /**Popup hiển thị cách chức năng chung */
      case "CommonDetailPopup":
        component = import("@/views/revenuemanagement/popup/CommonDetailPopup.vue");
        break;

      /**Popup hiển thị gửi yêu cầu thanh toán 1 người */
      case "SendPaymentRequestPopup":
        component = import("@/views/revenuemanagement/popup/SendPaymentRequestPopup.vue");
        break;

      /**Popup hiển thị gửi yêu cầu thanh toán nhiều người */
      case "SendMutiPaymentRequestPopup":
        component = import("@/views/revenuemanagement/popup/SendMutiPaymentRequestPopup.vue");
        break;

      /**Popup thêm kì cho thu hộ doanh nghiệp */
      case "CreatePeriodPopup":
        component = import("@/views/revenuemanagement/popup/CreatePeriodPopup.vue");
        break;

      /**Popup chuyển kì thu */
      case "TransitionPeriodPopup":
        component = import("@/views/revenuemanagement/popup/TransitionPeriodPopup.vue");
        break;

      /**Popup Duplicate kì thu */
      case "DuplicatePeriodPopup":
        component = import("@/views/revenuemanagement/popup/DuplicatePeriodPopup.vue");
        break;

      /**Popup xác nhận thanh toán */
      case "ChangePaidPopup":
        component = import("@/views/revenuemanagement/popup/ChangePaidPopup.vue");
        break;

      /**Popup xác nhận xoá YCTT */
      case "DeletePaymentRequestPopup":
        component = import("@/views/revenuemanagement/popup/DeletePaymentRequestPopup.vue");
        break;

      /**Popup xác nhận thanh toán multi*/
      case "ChangeMultiPaidPopup":
        component = import("@/views/revenuemanagement/popup/ChangeMultiPaidPopup.vue");
        break;

      /**Popup xem chi tiết chứng từ giao dịch */
      case "DetailPaymentRequestPopup":
        component = import("@/views/revenuemanagement/popup/DetailPaymentRequestPopup.vue");
        break;

      /**Popup xem chi tiết timeline */
      case "MsTimeLineLayout":
        component = import("@/views/revenuemanagement/layout/MsTimeLineLayout.vue");
        break;

      // Popup kết nối dịch vụ amis kế toán
      case "PopupSyncAmis":
        component = import("@/views/MemasSetting/PopupSyncAmis.vue");
        break;

      /**Popup nhập khẩu template YCTT không hợp lệ*/
      case "InvalidFilePopup":
        component = import("@/views/import/common/InvalidFilePopup.vue");
        break;
      /**
       * Hiển thị popup chi tiết giao dịch
       */
      case "MerchantTransactionControlDetail":
        component = import("@/views/TransactionControl/MerchantTransactionControlDetail.vue");
        break;

      case "HistoryPrivacyPolicy":
        component = import("@/views/dashboard/HistoryPrivacyPolicy.vue");
        break;
      case "ConvertToMisaId":
        component = import("@/layouts/Popup/PopupConvertToMisaId.vue");
        break;
      case "ConvertMisaIdResult":
        component = import("@/layouts/Popup/PopupConvertMisaIdResult.vue");
        break;
    }
    return component;
  }

  /**
   * Lấy ra options để truyền sang form dialog quickAdd cho một số tình huống đặc thù
   */
  _customParam(type, options) {}

  /**
   * Show form popup
   */
  _show(type, component, owner, options, data) {
    const me = this;
    var promise = new Promise((resolve, reject) => {
      if (owner && component) {
        let frm = commonFunction.renderDynamicElement(document.body, component, owner, {
          i18n,
          store,
        });
        if (frm) {
          //tracking để quản lý các popup đang hiển thị
          me._visible[type] = frm;
          frm.$$router = owner.$router;
          frm.$$route = owner.$route;

          //khi đóng form chi tiết -> lắng nghe để giải phóng
          frm.$on("close", function () {
            document.body.removeChild(frm.$el);
            delete frm.ownerForm;
            delete frm.editMode;
            delete frm.active;
            delete frm.$$router;
            delete frm.$$route;

            frm.$destroy();
            delete me._visible[type];

            //gọi hàm close nếu có
            if (options && typeof options.close === "function") {
              options.close();
            }
          });

          if (options) {
            //sự kiện dùng cho base quickSearch
            if (typeof options.searchSubmit === "function") {
              frm.$on("searchsubmit", options.searchSubmit);
            }
          }

          frm.ownerForm = owner;
          if (options.mode) {
            frm.editMode = options.mode;
          }

          if (typeof frm.active === "boolean") {
            frm.active = true;
          }
          if (typeof frm.show === "function") {
            frm.show(data, options);
          }
        }
      }
    });

    return promise;
  }

  /**
   * render element vào target element
   * @param {HTMLElement} target vùng target để render
   * @param {Object} owner Form/Component gọi show
   * @param {EnumQuickAdd} type Loại popup
   * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
   * @param {Object} options Các biến hỗ trợ điều khiền luồng
   * @public
   */
  append(target, owner, type, data, options) {
    var me = this,
      component = me._components[type];

    if (!type) {
      throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
    } else {
      var promise;
      options = options ? options : {};
      me._customParam(type, options);

      if (!component) {
        component = me._loadComponent(type);

        if (component) {
          promise = new Promise((resolve, reject) => {
            var fnSuccess = function (module) {
              if (module) {
                var popupModule = module.default;
                if (popupModule) {
                  me._components[type] = popupModule;
                  me._append(target, popupModule, owner, options, data).then(
                    (record) => {
                      resolve(record);
                    },
                    function (error) {
                      reject(error);
                      ư;
                    },
                  );
                }
              }
            };

            var fnFailure = function (error) {
              commonFunction.handleException(error);
              reject(error);
            };

            component.then(fnSuccess, fnFailure);
          });
        }
      } else {
        promise = me._append(target, component, owner, options, data);
      }

      return promise;
    }
  }

  /**
   * render show
   */
  _append(target, component, owner, options, data) {
    var promise = new Promise((resolve, reject) => {
      if (owner && component) {
        let frm = commonFunction.renderDynamicElement(target, component, owner, {
          i18n,
          store,
        });
        if (frm) {
          //khi đóng form chi tiết -> lắng nghe để giải phóng
          frm.$on("close", function () {
            if (typeof options.close === "function") {
              options.close();
            }

            target.removeChild(frm.$el);
            frm.$destroy();
          });

          //submit
          if (typeof options.submit === "function") {
            frm.$on("submit", options.submit);
          }

          frm.ownerForm = owner;
          if (options.mode) {
            frm.editMode = options.mode;
          }

          if (typeof frm.active === "boolean") {
            frm.active = true;
          }
          if (typeof frm.show === "function") {
            frm.show(data, options);
          }
        }
      }
    });

    return promise;
  }
}

export default new PopupUtil();
